import api from "@/api/api";
import {iniciarRequisicao, logout} from "@/helpers";
import {STATUS_HTTP} from "../../statusHTTP";

const PREFIXO = 'diagnostico/slow-no-moving/indicadores/movimentacao-estoque/historico/status';

export const buscarStatusMovimentacao = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(`/${PREFIXO}`, config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data;
}

export const buscarSegmentos = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(`/${PREFIXO}/segmentos`, config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarFornecedores = async (params) => {
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(`/${PREFIXO}/segmentos/fornecedores`, config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarProdutos = async (params) => {
  const url = `/${PREFIXO}/segmentos/fornecedores/produtos`;
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(url, config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.itens;
}

export const buscarProdutosDetalhamento = async (params) => {
  const url = `/${PREFIXO}/produtos`;
  const config = {params, headers: iniciarRequisicao()};
  const {data, status} = await api.get(url, config).catch(logout);

  if (status !== STATUS_HTTP.OK) {
    logout();
  }

  localStorage.token = data.token;
  return data.produtos;
}
